import { CheckboxGroup as NextCheckboxGroup } from "@heroui/react";
import { withFormComponent } from "./hoc";

export const CheckboxGroup = withFormComponent(NextCheckboxGroup); 